import { getOffset, smoothScrollTo } from './../../utilities/js/helper';
import './skip-content.scss';

class SkipContent {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-skipcontent',
            scrollAttr: 'data-skipcontent-scroll'
        };

        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;

        // Properties
        this.targetId = this.$root.getAttribute(this.settings.initAttr);
        this.scrollToIsActive = this.$root.hasAttribute(this.settings.scrollAttr);
    }

    initialize () {
        if (this.targetId) {
            this.setEvents();
        }
    }

    setEvents () {
        this.$root.addEventListener('click', (e) => {
            e.preventDefault();
            const $targetElement = document.getElementById(this.targetId);

            if ($targetElement) {
                $targetElement.focus();

                if (this.scrollToIsActive) {
                    const anchorDimensions = getOffset($targetElement.parentNode);
                    const anchorDimensionsTop = anchorDimensions.top - 250;
                    smoothScrollTo(0, anchorDimensionsTop, window.OPTIONS.speed);
                }
            }
        });
    }
}

export { SkipContent };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-skipcontent]');
        $$roots.forEach($root => {
            const $rootAPI = new SkipContent($root);
            $rootAPI.initialize();
        });
    }
});
